import React from "react";
import { GroupMember, useAppSelector } from "@lib/store";
import { Avatar } from "@molecules";
import { H4, Subtitle } from "@quarks";
import { useTranslation } from "react-i18next";

export const GroupMemberItem = ({ member: { user } }: { member: GroupMember }) => {
  const { t } = useTranslation();
  const currentUserId = useAppSelector(state => state.data.user.user.id);

  return (
    <div className={`grid grid-cols-[auto_1fr] gap-x-4 items-center w-full py-2 text-left`}>
      <Avatar user={user} />

      <div className="grid min-w-0">
        <H4 className="truncate">
          {user.name} {currentUserId === user.id && <span className="text-mapiq-black-500">({t("You")})</span>}
        </H4>
        <Subtitle className="text-sm truncate">{user.email}</Subtitle>
      </div>
    </div>
  );
};
